import { QueryClient } from '@tanstack/react-query';
import { persistQueryClient } from '@tanstack/react-query-persist-client';
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';

export const DASHBOARD_QUERY_STALE_TIME_MS = 90 * 1000;
export const DASHBOARD_QUERY_CACHE_TIME_MS = 10 * 60 * 1000;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: DASHBOARD_QUERY_STALE_TIME_MS,
      gcTime: DASHBOARD_QUERY_CACHE_TIME_MS,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

let persistenceInitialized = false;

export const setupQueryPersistence = () => {
  if (persistenceInitialized) return;
  if (typeof window === 'undefined' || !window.localStorage) return;

  const persister = createSyncStoragePersister({
    storage: window.localStorage,
    key: 'canalerts-react-query-cache',
  });

  persistQueryClient({
    queryClient,
    persister,
    maxAge: DASHBOARD_QUERY_CACHE_TIME_MS,
    dehydrateOptions: {
      shouldDehydrateQuery: query =>
        Array.isArray(query.queryKey) && query.queryKey[0] === 'dashboard',
    },
  });

  persistenceInitialized = true;
};
